import React from "react";
import { Grid, Typography } from "@mui/material";

export const TicketsTitle = () => {
  return (
    <Grid size={12}>
      <Typography
        component="h1"
        variant="h4"
        fontWeight={700}
        sx={{ mb: 3, textTransform: "uppercase" }}
      >
        Ticketing
      </Typography>
    </Grid>
  );
};
